<template>
  <div data-app>
    <v-nuevo-trafico :key="componentKey" />
  </div>
</template>

<script>
import nuevo from "@/views/trafico/NuevoTrafico.vue";

export default {
  components: {    
    "v-nuevo-trafico": nuevo,    
  },  
  mounted() {             

    this.$root.$on("forceRerender", val => {
      this.componentKey = this.$local_storage.get("referencia","sinreferencia") + val;
    });
      
  },
  
  data() {
    return { fab: false,
      componentKey: "0",            
    };
  },
};
</script>
